<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" sm="5" md="4">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="12" sm="5" md="4">
              <div class="text-right align-end justify-end d-flex">
                <v-text-field
                  :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                  v-model="search"
                  style="max-width: 600px"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="datatableItems"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_user="{ item }">
            <v-btn @click="$copy(item.id_user)" x-small>{{
              item.id_user
            }}</v-btn>
          </template>
          <template v-slot:item.deposit_paid_value="{ item }">
            <span :class="getColor(item.deposit_paid_value)">{{
              item.deposit_paid_value
            }}</span>
          </template>
          <template v-slot:item.withdraw_paid_value="{ item }">
            <span :class="getColor(item.withdraw_paid_value)">{{
              item.withdraw_paid_value
            }}</span>
          </template>
          <template v-slot:item.total="{ item }">
            <span :class="getColor(item.total)">{{ item.total }}</span>
          </template>
          <!-- T -->
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="showResume">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon
                  class="float-right mr-3 d-print-none"
                  @click="$copy(resumePrint)"
                >
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("deposits") }}</td>
                      <td class="text-right" :class="getColor(resume.deposits)">
                        <b>{{ $t("labelCurrency") }} {{ resume.deposits }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("withdrawals") }}</td>
                      <td
                        class="text-right"
                        :class="getColor(resume.withdraws)"
                      >
                        <b>{{ $t("labelCurrency") }} {{ resume.withdraws }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td class="text-right" :class="getColor(resume.value)">
                        <b>{{ $t("labelCurrency") }} {{ resume.value }}</b>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    breakPoint: "xs",

    resumePrint: "",

    showResume: false,

    deposits: [],
    withdraws: [],
    datatableItems: [],
    listDeposits: [],
    listWithdraws: [],
  }),

  computed: {
    headers() {
      return [
        {
          text: "ID",
          value: "id_user",
          sortable: false,
        },
        {
          text: this.$t("user"),
          value: "name_user",
          sortable: false,
        },
        {
          text: this.$t("amountOfDeposits"),
          value: "deposit_paid_count",
          sortable: true,
        },
        {
          text: this.$t("deposits"),
          value: "deposit_paid_value",
        },
        {
          text: this.$t("amountOfWithdrawals"),
          value: "withdraw_paid_count",
          sortable: true,
        },
        {
          text: this.$t("withdrawals"),
          value: "withdraw_paid_value",
        },
        {
          text: "Total",
          value: "total",
        },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },

    goTo() {
      return this.$store.state.filters.TabsNavigationButtons.route;
    },
    paymentProvider() {
      return this.$store.state.filters.paymentProvider.value;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getBankStatement();
    },
    goTo(val) {
      this.$router
        .push({
          name: val,
        })
        .catch(() => {});
    },
  },
  methods: {
    reset() {
      this.datatableItems = [];
      this.listDeposits = [];
      this.listWithdraws = [];
      this.resume = {};
      this.showResume = false;
    },

    // Consumo de API Sales Report General Online
    getBankStatement() {
      this.reset();
      const body = {
        ...this.rangeDate,
        payment_provider: this.paymentProvider,
      };
      this.$request
        .post("/colab/bankOnline/depositsAndWithdrawsGrouped", body)
        .then((response) => {
          if (!response.dados) return;
          this.datatableItems = response.dados;

          this.datatableItems.forEach((item) => {
            // Depostitos
            item.deposit_paid_value = Number(item.deposit_paid_value).toFixed(
              2
            );
            this.listDeposits.push(Number(item.deposit_paid_value));
            //Saques
            item.withdraw_paid_value = (
              Number(item.withdraw_paid_value) * -1
            ).toFixed(2);
            this.listWithdraws.push(Number(item.withdraw_paid_value) * -1);

            item.total =
              Number(item.deposit_paid_value) +
              Number(item.withdraw_paid_value);

            item.total = Number(item.total).toFixed(2);
          });

          this.buildResume(this.datatableItems);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Cria o Resumo
    buildResume(datatableItems) {
      if (!datatableItems) return;

      // // CHAVES QUE DEVEM SER SOMADAS
      let resume = {
        withdraws: {},
        deposits: {},
        value: {},
      };
      // SOMANDO OS VALORES DE SAQUES E DEPOSITOS
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      resume.withdraws = Number(
        this.listWithdraws.reduce(reducer) * -1
      ).toFixed(2);
      resume.deposits = Number(this.listDeposits.reduce(reducer)).toFixed(2);

      // TOTAL DO RESUMO
      resume.value = Number(resume.deposits) + Number(resume.withdraws);
      resume.value = Number(resume.value).toFixed(2);

      this.resume = resume;
      this.showResume = true;
      this.resumeExcelCopy();
    },

    // Botão de copiar no padrão do excel
    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `<table>
        <tr>${this.resume.deposits.toString().replace(".", ",")}</tr>
        <tr>${this.resume.withdraws.toString().replace(".", ",")}</tr>
        <tr>${this.resume.value.toString().replace(".", ",")}</tr>
     </table>`;
    },
    getColor(value) {
      if (value == 0) return "white--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    // Status for extratc
    statusOperationUI(value) {
      const obj = {
        1: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "authorized"
        )}</span></span>`,
        2: `<span class="my-1 v-chip theme--light v-size--small grey darken  white--text"><span class="v-chip__content">${this.$t(
          "requisted"
        )}</span></span>`,
        3: `<span class="my-1 v-chip theme--light v-size--small orange darken-3 white--text"><span class="v-chip__content">${this.$t(
          "consolidated"
        )}</span></span>`,
        4: `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${this.$t(
          "didCancelled"
        )}</span></span>`,
      };
      return obj[value];
    },
  },
};
</script>
